<template>
  <b-row class="mb-3">
    <b-col md="2">
      <label>Descripción*</label>
    </b-col>
    <b-col md="10">
      <b-form-input
        ref="input"
        v-model="oferta.descripcion"
        :readonly="disabled"
        type="text"
        placeholder="Nombre descriptivo de la oferta"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: mapState(useOfertaFormStore, ["oferta"]),
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>
